import { isEmpty, isNullish, isString } from "./typeHelpers";

/**
 * Clamp a number between a lower and upper limit.
 * @param {number} number
 * @param {number} lower Default: `-Infinity`
 * @param {number} upper Default: `Infinity`
 * @returns {number}
 */
export function clamp(number, lower = -Infinity, upper = Infinity) {
	if (number < lower) {
		return lower;
	}

	if (number > upper) {
		return upper;
	}

	return number;
}

/**
 * Parses a string to a number safely with a default value.
 * @param {string | null | undefined} str
 * @param {number} defaultValue
 * @returns
 */
export function safeParseNumber(str, defaultValue = 0) {
	if (isNullish(str)) {
		return defaultValue;
	}

	if (isString(str) && isEmpty(str)) {
		return defaultValue;
	}

	const parsed = +str;

	if (isNaN(parsed)) {
		return defaultValue;
	}

	return parsed;
}
